import { Global } from 'modules/reporting/raw';
import { RouteObject } from 'react-router';

export default {
  path: 'raw',
  element: <Global />,
} as RouteObject;
